import AdminAzureDevopsSettings from './AdminAzureDevopsSettings';

export default AdminAzureDevopsSettings;
